import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12c0 -3.314 4.03 -6 9 -6s9 2.686 9 6s-4.03 6 -9 6s-9 -2.686 -9 -6","key":"svg-0"}]]

/**
 * IconOvalVertical
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItb3ZhbC12ZXJ0aWNhbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyAxMmMwIC0zLjMxNCA0LjAzIC02IDkgLTZzOSAyLjY4NiA5IDZzLTQuMDMgNiAtOSA2cy05IC0yLjY4NiAtOSAtNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/oval-vertical
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconOvalVertical = createReactComponent('outline', 'oval-vertical', 'OvalVertical', __iconNode);

export default IconOvalVertical;